// extracted by mini-css-extract-plugin
module.exports = {"ivipBanner":"styles_ivipBanner__3up2o","ivipBannerTrack":"styles_ivipBannerTrack__2CG0m","ivipBannerText":"styles_ivipBannerText__1lhFD"};